module.exports = __webpack_public_path__ + "static/media/bn.c89b0993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bn.png
// module id = 1802
// module chunks = 0